<script setup>
import AppLayout from "@/Layouts/AppLayout.vue";
import FormSection from "@/Components/FormSection.vue";
import PrimaryButton from "@/Components/PrimaryButton.vue";
import SecondaryButton from "@/Components/SecondaryButton.vue";
import InputLabel from "@/Components/InputLabel.vue";
import TextInput from "@/Components/TextInput.vue";
import { useForm } from "@inertiajs/inertia-vue3";

const props = defineProps({
  code: Object,
  readOnly: { type: Boolean, default: false },
})

const form = useForm({
  _method: props.code?.ID ? "PUT" : "POST",
  itemid: props.code?.itemid || "",
  description: props.code?.description || "",
  price: props.code?.price ?? 0,
})

const saveForm = () => {
  const isEdit = !!props.code?.ID

  const routeName = isEdit
    ? route("admin.pricing.update", { pricing: props.code.ID })
    : route("admin.pricing.store")

  form.post(routeName, {
    preserveScroll: true,
    onSuccess: () => {
      if (!isEdit) {
        window.location.href = route("admin.pricing.index")
      }
    },
  })
}
</script>

<template>
  <AppLayout :title="props.code?.ID ? 'Edit Pricing Item' : 'New Pricing Item'">
    <template #header>
      <h2 class="font-semibold text-xl text-gray-800 leading-tight">
        {{ props.readOnly ? 'View Pricing Item' : (props.code?.ID ? 'Edit Pricing Item' : 'Create Pricing Item') }}
      </h2>
    </template>

    <div class="max-w-2xl mx-auto py-10 sm:px-6 lg:px-8">
      <FormSection gridClasses="grid-cols-1" :noGrid="true">
        <template #title>
          <a :href="route('admin.pricing.index')">
            <SecondaryButton>Back</SecondaryButton>
          </a>
        </template>

        <template #form>
          <div class="flex flex-col gap-4">
            <div>
              <InputLabel value="Item ID" />
              <TextInput
                v-model="form.itemid"
                class="w-full mt-1"
                :disabled="props.readOnly"
              />
              <div v-if="form.errors.itemid" class="text-red-600 text-sm mt-1">
                {{ form.errors.itemid }}
              </div>
            </div>

            <div>
              <InputLabel value="Description" />
              <TextInput
                v-model="form.description"
                class="w-full mt-1"
                :disabled="props.readOnly"
              />
              <div v-if="form.errors.description" class="text-red-600 text-sm mt-1">
                {{ form.errors.description }}
              </div>
            </div>

            <div>
              <InputLabel value="Price per hour" />
              <TextInput
                v-model="form.price"
                type="number"
                step="0.01"
                class="w-full mt-1"
                :disabled="props.readOnly"
              />
              <div v-if="form.errors.price" class="text-red-600 text-sm mt-1">
                {{ form.errors.price }}
              </div>
            </div>
          </div>
        </template>

        <template #actions>
          <PrimaryButton v-if="!props.readOnly" @click.prevent="saveForm">
            Save
          </PrimaryButton>
        </template>
      </FormSection>
    </div>
  </AppLayout>
</template>